import { type FC, useContext } from "react";
import { type TableColumnMap, TableComponent } from "../../Forms/DragDrop/ComponentBases/TableComponent";
import { DragDropComponentErrorContext } from "../../Forms/DragDrop/DragDropComponent";
import { DragDropDataContext } from "../../Forms/DragDrop/DragDropRenderer";
import { type ComponentOptions } from "../../Forms/DragDrop/DragDropTypes";
import { hasColumnsValue } from "../../Forms/DragDrop/ReorderableTableSettings";

const COLUMN_DEFINITIONS: TableColumnMap = {
    tax: {
        style: {
            textAlign: "right",
        },
    },
    total: {
        style: {
            width: "6em",
        },
    },
};

export const ReceiptTaxTableComponent: FC<ComponentOptions> = ({
    value,
    style,
}) => {
    const { tax } = useContext(DragDropDataContext);

    const error = useContext(DragDropComponentErrorContext);

    if(!hasColumnsValue(value)) {
        return error;
    }

    if(!Array.isArray(tax)) {
        return error;
    }

    return (
        <TableComponent
            noHeader
            columns={COLUMN_DEFINITIONS}
            value={value.columns}
            data={tax}
            style={style}
        />
    );
};
